// This component queries for course data to display on the LOHP.
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";
import {RequestInfo} from "@repo/shared-core";

import LearnMenuTopicsQuery from "#page-package/courses-menu/learn-menu-topics-query.ts";
import type {DomainObject} from "#page-package/types.ts";

import CourseList from "./course-list.tsx";

class CourseListContainer extends React.Component<Record<any, any>> {
    // This is hacky, but we desire a very specific order for
    // the "en" course list so that our most important courses
    // are above the fold for SEO purposes
    sortDomains(domains: Array<DomainObject>): Array<DomainObject> {
        if (RequestInfo.kaLocale !== "en") {
            return domains;
        }

        // The CourseList component will split the sortedDomains in half and
        // render two columns in desktop mode.
        const domainToIndex = {
            // Column 1
            "/math/k-8-grades": 0,
            "/math": 1,
            "/math/get-ready-courses": 2,
            "/ela": 3,
            "/college-careers-more": 4,
            // Column 2
            "/science": 5,
            "/test-prep": 6,
            "/computing": 7,
            "/humanities": 8,
            "/economics-finance-domain": 9,
        } as const;

        // The final list to be rendered
        const sortedDomains: Array<DomainObject> = [];
        // A temp list of domains we don't have sort index for. Will be
        // appended to the end of sortedDomains.
        const unexpectedDomains: Array<DomainObject> = [];

        domains.forEach((domain) => {
            // If we have a configured index, use it. We do this check in case
            // the domains change, hopefully it will break less
            if (typeof domainToIndex[domain.href] === "undefined") {
                unexpectedDomains.push(domain);
            } else {
                // otherwise push to the temp array
                sortedDomains[domainToIndex[domain.href]] = domain;
            }
        });

        // Add the unexpected domains to the list
        sortedDomains.push(...unexpectedDomains);

        return sortedDomains;
    }

    render(): React.ReactNode {
        return (
            <LearnMenuTopicsQuery ssr={true}>
                {({loading, error, domains}) => {
                    if (loading) {
                        return (
                            <View>
                                <CircularSpinner size="medium" />
                            </View>
                        );
                    }

                    if (error) {
                        return;
                    }

                    return (
                        <CourseList
                            expandedByDefault={true}
                            domains={this.sortDomains(domains)}
                        />
                    );
                }}
            </LearnMenuTopicsQuery>
        );
    }
}

export default CourseListContainer;
